// pt-BR.js
export default {
  signIn: 'Entrar',
  user: 'Usuário',
  password: 'Senha',
  start: 'Inicio',
  revenues: 'Faturamento',
  financial: 'Financeiro',
  store: 'Loja',
  vouchers: 'Vouchers',
  voucherCreate: 'Criar Voucher',
  informAmount: 'Informe a Quantidade de 1 até 25',
  sales: 'Vendas',
  pole: 'Polo',
  poles: 'Polos',
  poleCreate: 'Criar Polo',
  poleName: 'Nome Polo',
  poleView: 'Visualizar Polo',
  createAnother: 'Criar outro polo',
  invalidUserOrPassword: 'Usuário ou senha inválido',
  hello: 'Olá',
  welcomeToYourAdministration: 'Bem vindo a sua administração.',
  logout: 'Logout',
  selectAUnit: 'Selecione a unidade',
  plan: 'Plano',
  value: 'Valor',
  discount: 'Desconto',
  totalItemValue: 'Valor total item',
  total: 'Total',
  retroactive: 'Retroativo',
  referenceMounth: 'Mês Referência',
  studentName: 'Nome Aluno',
  moduleTitle: 'Título Módulo',
  class: 'Aula',
  billable: 'Faturável',
  registrationDate: 'Data Registro',
  billed: 'Faturado',
  unbilled: 'Não Faturado',
  selectAProduct: 'Selecione um produto',
  selectAPlan: 'Selecione um plano',
  all: 'Todos',
  available: 'Disponível',
  inUse: 'Em Uso',
  consumed: 'Consumido',
  product: 'Produto',
  products: 'Produtos',
  productCreate: 'Criar Produto',
  productEdit: 'Editar Produto',
  last7Days: 'Últimos 7 dias',
  last30Days: 'Últimos 30 dias',
  period: 'Período',
  status: 'Status',
  registerDate: 'Data de Cadastro',
  expiredOn: 'Expirado Em',
  student: 'Aluno',
  saleDate: 'Data da venda',
  typeOfSale: 'Tipo venda',
  dueDate: 'Vencimento',
  paymentStatus: 'Status Pagamento',
  formOfPayment: 'Forma de Pagamento',
  installments: 'Parcelas',
  installmentValue: 'Valor parcela',
  quantity: 'Quantidade',
  interest: 'Juros',
  dispatch: 'Frete',
  totalPaid: 'Total pago',
  externalCode: 'Código externo',
  searchPoleName: 'Buscar nome do polo',
  adminName: 'Nome administrador',
  adminEmail: 'Email administrador',
  invalidEmail: 'Email inválido',
  creatingPole: 'Criando polo',
  successfullyCreated: 'Criado com sucesso',
  hash: 'Hash',
  genaratedDate: 'Data Gerado',
  signature: 'Assinatura',
  trail: 'Trilha',
  course: 'Curso',
  enrollmentDate: 'Data Matrícula',
  rg: 'RG',
  cpf: 'CPF',
  address: 'Endereço',
  number: 'Número',
  complement: 'Complemento',
  neighborhood: 'Bairro',
  city: 'Cidade',
  state: 'Estado',
  legalPerson: 'Pessoa Juridíca',
  physicalPerson: 'Pessoa Fisíca',
  selectedPearson: 'Selecione Pessoa Física ou Jurídica',
  admNameStatus: 'Informe o nome do administrador do polo',
  poleNameStatus: 'Informe o nome do polo',
  rgStatus: 'Informe o RG',
  cpfStatus: 'Informe o CFP',
  telefoneStatus: 'Informe o Telefone com DDD',
  celularStatus: 'Informe o Celular com DDD',
  nomeFantasiaStatus: 'Informe o nome fantasia',
  razaoSocialStatus: 'Informe a razão social',
  cnpjStatus: 'Informe o CNPJ',
  ieStatus: 'Informe o IE',
  logradouroStatus: 'Informe o endereço',
  numberStatus: 'Informe o número',
  complementoStatus: 'Informe o complemento',
  neighborhoodStatus: 'Informe o bairro',
  cityStatus: 'Informe a cidade',
  stateStatus: 'Informe o estado',
  cepStatus: 'Informe o CEP',
  nomeFantasia: 'Nome Fantasia',
  razaoSocial: 'Razão Social',
  cnpj: 'CNPJ',
  ie: 'IE',
  cep: 'CEP',
  differentPaymentAddress: 'Endereço de Pagamento Diferente?',
  differentShippingAddress: 'Endereço de Entrega Diferente?',
  addressMain: 'Endereço Principal',
  telefone: 'Telefone',
  celular: 'Celular',
  franchisor: 'Franqueadora',
  franchisors: 'Franqueadoras',
  franchisorCreate: 'Criar Franqueadora',
  franchisorEdit: 'Editar Franqueadora',
  coupons: 'Cupons',
  couponCreate: 'Criar Cupom',
  createCoupon: 'Criar Cupom',
  addCoupon: 'Adicionar Cupom',
  searchCouponName: 'Buscar Cupom',
  couponName: 'Nome Cupom',
  active: 'Ativo',
  inactive: 'Inativo',
  type: 'Tipo',
  startDate: 'Data Inicial',
  language: 'PT-br',
  typeCoupom: 'Tipo do Cupom',
  activeCoupon: 'Cupom Ativo',
  selectAType: 'Selecione um tipo',
  couponEdit: 'Editar Cupom',
  couponExists: 'O cupom já existe',
  validateDate: 'Data de vencimento inválida',
  couponAdd: 'Cupom adicionado com sucesso!',
  couponEdited: 'Cupom alterado com sucesso!',
  validatePercentage: 'Porcentagem acima de 100%',
  code: 'Código',
  sections: 'Seções',
  sectionCreate: 'Criar Seção',
  sectionEdit: 'Editar seção',
  searchSection: 'Buscar seção',
  searchPaymentPlan: 'Buscar Plano Pagamento',
  searchProduct: 'Buscar Produto',
  havePaymentPlan: 'Seção possui plano de pagamento?',
  haveProduct: 'Seção possui produto?',
  dropFile: 'Solte o arquivo aqui...',
  chooseImageSection: 'Escolha uma imagem para a Seção, tamanho recomendado 350x326px',
  BadRequestCoupon: 'Alterações não realizadas no Cupom',
  alertPlanAtSection: 'Só é permitido um plano de pagamento por Seção',
  changePlanSectionMessageSucess: 'Plano alterado com sucesso',
  changePlanSectionMessageError: 'Não foi possível alterar o plano',
  SectionProductUpdateMessage: 'Produto atualizado na seção com sucesso',
  chooseImageSection: 'Escolha uma imagem para a Seção, tamanho recomendado 350x326px',
  nomeCompletoDocumento: 'Nome Completo (Documento)',

  paymentPlans: 'Planos de Pagamento',
  paymentPlanCreate: 'Criar Plano de Pagamento',
  searchPaymentPlanName: 'Buscar Plano de pagamento',
  paymentPlanName: 'Nome Plano de pagamento',
  paymentPlanEdit: 'Editar Plano de pagamento',
  paymentPlanEdited: 'Plano de pagamento alterado com sucesso!',
  paymentPlanAdd: 'Plano de pagamento adicionado com sucesso!',


  configurationPlans: 'Planos de Configuração',
  configurationPlanCreate: 'Criar Plano de Configuração',
  searchConfigurationPlansName: 'Buscar Plano de Configuração',
  configurationPlansType: 'Tipo Plano Pagamento',
  description: 'Descrição',
  qtyTimes: 'QtdVezes',
  entryPercentage: 'Entrada %',
  discountPercentage: 'Desconto %',
  interestPercentage: 'Juros %',
  main: 'Principal',
  emphasis: 'Destaque',
  installmentLimitValue: 'Valor Limite Parcela',

  selectCouponTypeApplication: 'Selecione o tipo de aplicação do cupom',
  couponTypeApplication: 'Tipo de Aplicação',
  firstPurchase: 'Primeira Compra',
  enableRecurrence: 'Habilitar Recorrência?',

  // Novas traduções para os campos de cupom
  qtdeAplicacao: 'Aplicações por Produto',
  validateQtdeAplicacao: 'O número de aplicações não pode ser negativo',
  idCupomRecorrencia: 'Recorrência',
  qtdeUso: 'Limite de Uso',
  validateQtdeUso: 'O limite de uso não pode ser negativo',

  // Tipos de recorrência
  recorrenciaNenhuma: 'Sem Recorrência',
  recorrenciaDiaria: 'Diária',
  recorrenciaSemanal: 'Semanal',
  recorrenciaMensal: 'Mensal',
  recorrenciaAnual: 'Anual',

  // Novas traduções para a gamificação
  gamification: 'Gamificação',
  selectedPole: 'Polo Selecionado',
  selectedPoles: 'Polos Selecionados',
  itemsPerPage: 'Itens por página',
  gamified: 'Gamificado',
  aguardandoProcesso: 'Aguardando Processo',
  processando: 'Em Andamento',
  concluido: 'Concluído',
  erro: 'Erro',

  saleStatus: 'Status da Venda',
  orderCode: 'Código do Pedido',
  selectASalesStatus: 'Selecione o status da venda',
  customerName: 'Nome Cliente',
  shippingValue: 'Valor Frete',
  totalValue: 'Valor total',
  order: 'Pedido',
  free: 'Grátis',
  ticket: 'Boleto',
  creditCard: 'Cartão de Crédito',
  periodDate: 'Período por data',
  statusSale: 'Status Venda',
  productName: 'Nome produto',
  productValue: 'Valor Total Produto',

  exportToSpreadsheet: 'Exportar para planilha',
  generatingSpreadsheet: 'Gerando planilha...',
  exportCompleted: 'Exportação concluída',
  retroactiveProcess: 'Processo retroativo',
  orders: 'Pedidos',
  totalOrders: 'Total dos pedidos',
  productsSold: 'Produtos vendidos',
  averageTicket: 'Ticket médio',
  noSalesFound: 'Nenhuma venda encontrada.',
  fetchingPoleInfo: 'Buscando informações do polo...',
  poleStatus: 'Status do Polo',
  statusUpdatedSuccessfully: 'Status atualizado com sucesso!',
  unableToProcessRequest: 'Não foi possível processar a solicitação, tente novamente mais tarde.',
  pleaseDescribeWhatYouWantToChange: 'Por favor, descreva o que deseja alterar.',
  requestSentSuccessfully: 'Sua solicitação foi enviada com sucesso!',
  requestChange: 'Solicitar Alteração',
  whatWouldYouLikeToChange: 'O que você gostaria de alterar?',
  cancel: 'Cancelar',
  sending: 'Enviando...',
  sendRequest: 'Enviar Solicitação',
  deliveryAddress: 'Endereço de Entrega',
  billingAddress: 'Endereço de Cobrança',
  street: 'Logradouro',
  shortNumber: 'Nº',
  uf: 'UF',

  Ativo: 'Ativo',
  Inativo: 'Inativo',
  Suspenso: 'Suspenso',

  sale: 'Venda',
  expedition: 'Expedição',
  shipmentType: 'Tipo Expedição',
  automatic: 'Automático',
  manual: 'Manual',
  idExpedition: 'Código da Expedição',
  discountValue: 'Valor Desconto',
  couponCode: 'Código Cupom',
  omieOrder: 'Pedido na Omie',
  unitValue: 'Valor Unitário',
  discountformat: 'Desconto Formatado',

  DatePayment: 'Data Pagamento',
  StatusPayment: 'Status Pagamento',

  progressiveDiscount: 'Desconto Progressivo',
  progressiveDiscountCreate: 'Criar Desconto Progressivo',
  progressiveDiscountEdit: 'Editar Desconto Progressivo',
  progressiveDiscountName: 'Nome do Desconto Progressivo',
  progressiveDiscountType: 'Tipo de Desconto Progressivo',
  searchProgressiveDiscount: 'Buscar desconto',
  searchProducts: 'Buscar produtos',
  linkProducts: 'Vincular Produtos',
  quantityRange: 'Faixa de Quantidade',
  defineMaxQty: 'Definir Qtd Máxima?',
  productAlreadyLinkedToAnotherDiscount: 'Este produto já está vinculado a outro desconto progressivo',
  name: 'Nome',
  price: 'Preço',
  priceLessThanDiscount: 'Preço < Desconto',
  discountRangePriceAlert: 'Produtos com preço menor que o valor do desconto não poderão ser vinculados.',
  duplicateFaixaRange: 'Não é permitido ter faixas com o mesmo intervalo.',
  section: 'Seção',
  save: 'Salvar',
  activateOrDeactivateDiscount: 'Ativar ou Desativar Desconto',
  selectType: 'Selecione o tipo...',
  initialPeriod: 'Período Inicial',
  endPeriod: 'Período Final',
  percentage: 'Porcentagem (%)',
  realBrl: 'Real Brasileiro (R$)',
  discountValuePercentage: 'Valor do Desconto (%)',
  discountValueBrl: 'Valor do Desconto (R$)',
  minQuantity: 'Quantidade Mínima',
  idSection: 'Id Seção',
  idProduct: 'Id Produto',
  createdDate: 'Data de Cadastro',
  maxQuantity: 'Quantidade Máxima',
  addFaixa: 'Adicionar Faixa',
  removeFaixa: 'Remover Faixa',
  faixa: 'Faixa',
  noFaixasConfigured: 'Nenhuma faixa de quantidade configurada. Clique no botão abaixo para incluir uma faixa.',
  discountType: 'Tipo do Desconto'
};
